import { render, staticRenderFns } from "./settings-device-activity-details.vue?vue&type=template&id=65276b67&"
import script from "./settings-device-activity-details.vue?vue&type=script&lang=js&"
export * from "./settings-device-activity-details.vue?vue&type=script&lang=js&"
import style0 from "./settings-device-activity-details.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports